import { createApp } from "vue";

import TabComponent from "./TabComponent.vue";


const handle = "almero-vue-tab-component";
const mountEls = document.querySelectorAll(`.${handle}`);

mountEls.forEach((mountEl) => {
    let props = {};
    try {
        props = JSON.parse(mountEl.dataset.rootProps);
    }
    catch (e) {
        console.error(e);
    }
    const app = createApp(
        TabComponent, {
            ...props,
        }
    );
    app.mount(mountEl);
});